export const FREEDOM_PAY_PAYMENT_ID = '9PGDGvzvrKfJ366ZBz09h2e0pr13RMSA9wAmerk4C1gJ3v15mO';

export * from './sectors';
export * from './appConfig';
export * from './clients';
